<template>
	<div>
		<div style="display: flex;justify-content: space-between;align-items: center;">
			<!-- 是否有定位显示内容 如果有则进行图片定位显示 内容的名称 定位到图片最上边 进行显示隐藏和切换的功能 -->
			<div v-if="loactionEleArr.length > 0" class="project_title" :style="'width:'+(loactionEleArr.length*160+20)+'px'">
				<el-checkbox-group v-model="checkboxGroup" fill="#ED8546" class="check_group" @change="handleCheckedChange">
					<el-checkbox-button v-for="(locationEle,lIndex) in loactionEleArr" :label="locationEle.fieldCnName" :key="lIndex"><i
						 class="el-icon-share"></i>{{locationEle.fieldCnName}}</el-checkbox-button>
				</el-checkbox-group>
			</div>
			<el-button type="primary" icon="el-icon-document-add" size="mini" @click="dialogVisible = true">新建电子围栏</el-button>
		</div>
		<div class="kw_location_image">
			<!-- 放大 缩小图片 -->
			<div class="set_ratio">
				<img src="./img/enlarge.png" alt="" class="set_img" @click="addWidth">
				<el-divider class="dividing_line"></el-divider>
				<img src="./img/narrow.png" alt="" class="set_img" @click="subWidth">
			</div>
			<canvas ref="canvas" :width="imgWidth" :height="imgHeight" class="canvas"></canvas>
			<img ref="canvasImg" class="img_style" :class="zdyClass" :style="(styleSet.pageFieldImageStyleSet?styleSet.pageFieldImageStyleSet.styleSetCode:'')+(imgWidth>0?'width:'+imgWidth+'px;height:'+imgHeight+'px;':'')"
			 kwName="pageFieldImageStyleSet" :src="GLOBAL.getFileServeUrl()+imgSrc" />

			<template v-if="establishEnclosure.length>0" >
				<template v-for="(item,index) in establishEnclosure" >
					<vue-draggable-resizable class="establishDraggable" :key="'dragg_'+index" :w="item.width"
					:h="item.height" :x="item.x" :y="item.y" :parent="true" v-on:dragging="onDrag" v-on:resizing="onResize" style="z-index: 100;border: 1px dashed #1AAD19;">
						<span>{{item.name}}</span>
					</vue-draggable-resizable>
				</template>
			</template>


			<!-- 具体的定位内容的内容显示 -->
			<div v-for="(locationEle,lCIndex) in loactionEleArr" :key="lCIndex">
				<div v-for="(locationEleOne,leoIndex) in locationEle.fieldOne.childPageJsonArr" :key="leoIndex">
					<!-- <img :src="GLOBAL.getFileServeUrl()+locationEleOne.dataInfo.BG_FILE" :style="'position: absolute;top:'+ locationEleOne.Y + ';left:'+locationEleOne.X+';'+(locationEleOne.zdyStyle?locationEleOne.zdyStyle:'')"
					 :class="checkStationInx == leoIndex?'arrow_box':''" class="stationImg" @click="checkStation(leoIndex)" /> -->
					<img :src="GLOBAL.getFileServeUrl()+locationEleOne.dataInfo.BG_FILE" :style="'position: absolute;top:'+ locationEleOne.Y + ';left:'+locationEleOne.X+';'+(locationEleOne.zdyStyle?locationEleOne.zdyStyle:'')"
					 :class="checkStationInx == leoIndex && locationEleOne.zdyStyle?'arrow_box':''" class="stationImg" @click="checkStation(leoIndex,locationEleOne.status)" />
				</div>
			</div>
		</div>

		<el-dialog title="新建电子围栏" :show-close="!1" :visible.sync="dialogVisible" width="300px" :before-close="handleClose"
		 center>
			<span slot="footer" class="dialog-footer">
				<el-form>
					<el-form-item label="名称:">
						<el-input type="text" v-model="establishEnclosureName" style="width: 210px;" size="small"></el-input>
					</el-form-item>
					<!-- <el-form-item label="宽度:">
						<el-input type="text" v-model="establishEnclosure[0].width" style="width: 210px;" size="small"></el-input>
					</el-form-item>
					<el-form-item label="高度:">
						<el-input type="text" v-model="establishEnclosure[0].height" style="width: 210px;" size="small"></el-input>
					</el-form-item> -->
				</el-form>
				<el-button round @click="establish()" class="establishBtn">创 建</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import VueDraggableResizable from '@/components/ppt/vue-draggable-resizable.vue'
	export default {
		name: 'kw_location_image',
		props: {
			item: {
				type: Object,
				default: null
			},
			styleSet: {
				type: Object,
				default: null
			},
			imgSrc: {
				type: String,
				default: null
			},
			imgSrcArr: {
				type: Array,
				default: null
			},
			zdyClass: {
				type: String,
				value: 'RankingImg'
			},
			pageSetInfo: {
				type: Object,
				default: null
			},
			dataInfo: {
				type: Object,
				default: null
			}
		},
		data() {
			return {
				imgList: [],
				loactionEleArr: [],
				imgWidth: 0,
				imgHeight: 0,
				checkboxGroup: [],
				// 新建电子围栏
				dialogVisible: false,
				establishEnclosure: [],
				//电子围栏名称
				establishEnclosureName: '',
				//选中基站索引
				checkStationInx: 0,
			};
		},
		created() {
			var that = this;
			var imgSrcArr = that.imgSrcArr;
			var fileServeUrl = this.GLOBAL.getFileServeUrl();
			var arr = []
			if (imgSrcArr && imgSrcArr.length > 0) {
				imgSrcArr.forEach(one => {
					arr.push(fileServeUrl + one)
				})
			} else {
				arr.push(fileServeUrl + that.imgSrc);
			}
			that.imgList = arr;
			console.log(that.imgList, 'imgListimgListimgListimgListimgListimgListimgListimgList');
			//判断是否有需要进行图片中定位显示的内容 如果有则进行循环显示
			if (that.pageSetInfo) {
				that.loadLoactionEle(window.innerWidth);
			}
		},
		mounted() {
			this.intCanvas()
			console.log("%c平面图！！！","color:red;font-size:24px")
		},
		watch: {},
		computed: {},
		components: {
			VueDraggableResizable
		},
		methods: {
			onResize: function(x, y, width, height) {
				this.x = x;
				this.y = y;
				this.width = width;
				this.height = height;
				console.log(x, y, width, height)
			},
			onDrag: function(x, y) {
				this.x = x;
				this.y = y;
				console.log(x, y)
			},
			// 创建电子围栏
			establish() {
				var index = this.establishEnclosure.length
				var newObject = {
					name: this.establishEnclosureName,
					width: 150,
					height: 150,
					id: 'establish_'+index,
					x: 500,
					y: 500,
				}
				this.establishEnclosure.push(newObject)
				this.dialogVisible = false
			},
			// 选中基站&头像
			checkStation(val,status) {
				// status:1  基站  0  人物图标
				if(status == 0)return
				this.checkStationInx = val
			},
			// 选中显示内容
			handleCheckedChange(val) {
				console.log(val)
			},
			handleClose(done) {
				done();
			},
			// 绘图
			intCanvas(size) {
				var that = this
				// var coordinate = this.establishEnclosure[0].coordinate
				let canvas = this.$refs.canvas
				// 放大缩小比率
				var ratioSize = 1
				canvas.width = this.imgWidth
				canvas.height = this.imgHeight
				if(size == 1)ratioSize = this.imgWidth/window.innerWidth
				
				// console.log(ratioSize, 'ratioSize放大缩小比率')
				var ctx = canvas.getContext('2d')
				// 鼠标点击划线
				// canvas.onmousedown = function(ev) {
				// 	var ev = ev || window.event;
				// 	ctx.moveTo(ev.clientX - canvas.offsetLeft, ev.clientY - canvas.offsetTop);
				// 	var mousePos = mouseCoords(ev); 
				// 	var mousePosX = mousePos.x;
				// 	var mousePosY = mousePos.y;
				// 	console.log(mousePosX);
				// 	console.log(mousePosY);
				// 	console.log(ev);
				// 	var offsetX = ev.offsetX
				// 	var offsetY = ev.offsetY
				// 	var a ={x:offsetX,y:offsetY}
				// 	coordinate.push(a)
				// 	console.log(coordinate)
				// 	ctx.beginPath();
				// 	ctx.arc(offsetX,offsetY,5,0,2*Math.PI);
				// 	ctx.fillStyle="#000";
				// 	ctx.fill();
				// 	ctx.stroke();

				// document.onmousemove = function(ev) {
				// 	var ev = ev || window.event;
				// 	ctx.lineTo(ev.clientX - canvas.offsetLeft, ev.clientY - canvas.offsetTop);
				// 	ctx.stroke();
				// };
				// document.onmouseup = function() {
				// 	document.onmousemove = null;
				// 	document.onmouseup = null;
				// };
				// }
				var a =[{x:997,y:520},{x:997,y:600},{x:420,y:600},{x:420,y:450}]

				
				
				//注意，Canvas的坐标系是：Canvas画布的左上角为原点(0,0)，向右为横坐标，向下为纵坐标，单位是像素(px)。
				//开始一个新的绘制路径
				console.log(canvas)
				ctx.beginPath();
				ctx.strokeStyle="red";
				ctx.rect(772*ratioSize,267*ratioSize,200*ratioSize,200*ratioSize);
				ctx.stroke();
				
				ctx.beginPath();
				//定义直线的起点坐标为(0,0)
				console.log(a,a[0].x*ratioSize)
				ctx.moveTo(a[0].x*ratioSize, a[0].y*ratioSize);
				for(var i=1;i<a.length;i++){
					// ctx.lineTo(i.x*ratioSize, i.y*ratioSize);
					console.log('1')
				}
				// ctx.moveTo(977*ratioSize, 520*ratioSize);
				//定义直线的终点坐标为(x,y)
				ctx.lineTo(977*ratioSize, 600*ratioSize);
				ctx.lineTo(420*ratioSize, 600*ratioSize);

				ctx.lineTo(420*ratioSize, 450*ratioSize);

				// 图形填充色
				// canvas.fillStyle="#FFFFFF"
				// ctx.fill();
				// 线条的颜色
				ctx.lineWidth = 1;
				ctx.strokeStyle = "#3581CC";
				//沿着坐标点顺序的路径绘制直线
				
				ctx.stroke();
				// //关闭当前的绘制路径
				ctx.closePath();
			},
			/**
			 * 图片放大
			 */
			addWidth() {
				var that = this
				this.loadLoactionEle(this.imgWidth + 100);
				setTimeout(() => {
					that.intCanvas(1)
				}, 100);
			},
			/**
			 * 图片缩小
			 */
			subWidth() {
				var that = this
				this.loadLoactionEle(this.imgWidth - 100);
				setTimeout(() => {
					that.intCanvas(1)
				}, 100);

			},
			// 加载所有的数据并显示 根据当前宽度
			loadLoactionEle(nowWidth) {
				var that = this;
				that.imgWidth = nowWidth;
				var maxWidth = that.dataInfo.MAX_WIDTH;
				var maxHeight = that.dataInfo.MAX_HEIGHT;
				//获取浏览器的宽度 进行图片的宽高比计算
				// console.log("Window.innerWidth==================",window.innerWidth);
				that.imgHeight = that.imgWidth * (maxHeight / maxWidth);
				var loactionEleArr = [];
				//获取查看页面字段的
				that.pageSetInfo.fieldSet.forEach((item, index) => {
					// 定位组件-内容
					if (item.styleSet && item.styleSet.showStyle == 27) {
						var locationEleOne = {};
						locationEleOne.fieldCnName = item.fieldCnName;
						locationEleOne.index = index;
						locationEleOne.fieldOne = item;
						//计算当前元素的显示位置
						that.countLoaction(locationEleOne);
						loactionEleArr.push(locationEleOne);
						// item.childFieldSet
						// item.childPageJsonArr.childStyleSet
						// .dataInfo
					}
				})
				console.log("loactionEleArr==============================================", loactionEleArr);
				that.loactionEleArr = loactionEleArr;
				that.checkboxGroup[0] = loactionEleArr[0].fieldCnName
			},
			/**
			 * 计算显示位置
			 */
			countLoaction(locationEleOne) {
				var that = this;
				var maxWidth = that.dataInfo.MAX_WIDTH;
				var maxHeight = that.dataInfo.MAX_HEIGHT;
				console.log("locationEleOne.fieldOne============================", locationEleOne.fieldOne);
				locationEleOne.fieldOne.childPageJsonArr.forEach((item, index) => {
					var nowX = item.dataInfo.LOCATION_X;
					var nowY = item.dataInfo.LOCATION_Y;
					var locationWidth = item.dataInfo.LOCATION_WIDTH;
					var paddingWidth = 0;
					if (locationWidth > 0) {
						paddingWidth = locationWidth * (that.imgWidth / maxWidth);
					}
					item.X = (that.imgWidth * (nowX / maxWidth) - paddingWidth) + 'px';
					item.Y = (that.imgHeight * (nowY / maxHeight) - paddingWidth) + 'px';
					if (paddingWidth > 0) {
						// item.zdyStyle = "border-radius: 50%;border: 1px solid #000;padding:" + paddingWidth + "px;";
						item.zdyStyle = "border-radius: 50%;padding:" + paddingWidth + "px;";
						item.status = 1
					}else{
						item.status = 0
					}
				})
			},
			/**
			 * 点击文字时触发 图片的预览点击事件
			 */
			imgYu() {
				//      console.log(this.$refs.el_image);
				//      this.$refs.el_image.clickHandler();
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.kw_location_image {
		background: #fff;
		position: relative;
	}

	.RankingImg {
		width: 100%;
		display: block
	}

	.checkLook {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		top: 0;
		height: 32px;
		background: #000;
		opacity: 0.5;
		color: #fff;
		width: 110px;
		text-align: center;
		font-size: 16px;
		line-height: 32px;
		border-radius: 32px;
		margin: auto;
	}

	.commentImg {
		height: 70px;
		width: 90px
	}

	.imageStyle {
		display: block;
		width: 100%;
		padding: 10px
	}

	.img_style {
		width: 100%
	}

	.project_title {
		font-size: 15px;
		box-shadow: 0px 0px 5px #7a7a7a;
		padding: 10px 0;
		margin: 5px 0;
	}

	.check_group {
		display: flex;
		align-items: center;
		justify-content: space-around;
	}

	.project_item_name {
		min-width: 170px;
		text-align: center;
	}

	.active_project_item_name {
		background: #ED8546;
	}

	.establishBtn {
		background: #ED8546;
		color: #fff;
		font-weight: bold;
		padding: 8px 40px;
		font-size: 16px;
		margin-top: 20px;
	}

	.set_ratio {
		position: absolute;
		top: 0;
		right: 0;
		background: #82858A;
		padding: 10px 8px;
		z-index: 99;
	}

	.set_img {
		width: 26px;
		height: 26px;
	}

	.set_ratio .el-divider--horizontal {
		margin: 5px 0;
		background-color: #000;
	}

	.stationImg {
		z-index: 99;
	}
	.establishDraggable span{
		font-size: 16px;
		font-weight: bold;
		display: block;
		text-align: center;
		height: 100%;
		color: #1AAD19;
	}
	.establishDraggable:hover{
		cursor: move
	}




	.canvas {
		position: absolute;
		top: 0;
		left: 0;
		z-index: 98;
	}

	/* 边框闪烁 */
	.arrow_box {
		animation: glow 1000ms ease-out infinite alternate;
	}

	@keyframes glow {
		0% {
			border-color: #F28947;
			box-shadow: 0 0 5px rgba(254, 126, 51, .2), inset 0 0 5px rgba(254, 126, 51, .1), 0 1px 0 #F28947;
		}

		100% {
			border-color: #F6863C;
			box-shadow: 0 0 20px rgba(254, 126, 51, .6), inset 0 0 10px rgba(254, 126, 51, .4), 0 1px 0 #F6863C;
		}
	}
</style>
<style>
	.check_group .el-checkbox-button__inner {
		padding: 5px 10px;
		border-radius: 12px !important;
		border: none !important;
		font-weight: bold;
	}
	.establishDraggable .handle{
		border-color: #1AAD19;
		background-color: #1AAD19;
	}
</style>
